@if (livestreamType !== undefined) {
  <a class="back-btn" (click)="back()">
    <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.59961 9L1.59961 5L5.59961 1M1.59961 5H22.3996H1.59961Z"
        stroke="#333333"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </a>
}
<h2 mat-dialog-title class="title" tabindex="0">{{ headerInfo.title }}</h2>
@if (!showPreviewSection) {
  <div mat-dialog-content>
    <p tabindex="0">{{ headerInfo.subTitle }}</p>
    @if (livestreamType === undefined) {
      <div class="form-field">
        <label class="text-color-grey-700 uppercase font-s weight-bold">Service</label>
        <mat-select [(value)]="livestreamTypeSelected" placeholder="Livestream type">
          @for (type of livestreamServicesTypes; track type) {
            <mat-option [value]="type">{{ type }}</mat-option>
          }
        </mat-select>
      </div>
    }
    @if (livestreamType === 'HLS') {
      <form [formGroup]="hlsForm">
        <mat-form-field>
          <mat-label>LABEL STREAM</mat-label>
          <input matInput formControlName="labelStream" (keydown)="onInputKeyDown($event)" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>STREAM URL</mat-label>
          <input matInput formControlName="streamUrl" (keydown)="onInputKeyDown($event)" />
        </mat-form-field>
      </form>
    }
    @if (livestreamType === 'RTMP') {
      <form [formGroup]="rtmpForm">
        <mat-form-field>
          <mat-label>LABEL STREAM</mat-label>
          <input matInput formControlName="labelStream" (keydown)="onInputKeyDown($event)" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>STREAM URL</mat-label>
          <input matInput formControlName="streamUrl" (keydown)="onInputKeyDown($event)" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>STREAM KEY</mat-label>
          <input matInput formControlName="streamKey" (keydown)="onInputKeyDown($event)" />
        </mat-form-field>
      </form>
    }
    @if (previewError) {
      <div class="error-message">{{ getPreviewError() }}</div>
    }
  </div>
}

@if (showPreviewSection) {
  <div mat-dialog-content>
    <div class="preview-livestream-container">
      <div class="preview-container">
        @if (isPreviewLoading) {
          <app-loading></app-loading>
        }
        <video #previewVideo id="livestream-video" autoplay></video>
      </div>
    </div>
    <div class="broadcast-container">
      @if (currentView === 'manage_presenters') {
        <div class="row">
          <mat-radio-button
            [checked]="broadcastNow"
            color="primary"
            [disabled]="isLivestreamActive || isPresentationFull"
            (change)="broadcastNow = true"
            >Broadcast Now</mat-radio-button
          >
        </div>
      }
      <div class="row">
        <mat-radio-button (change)="broadcastNow = false" [checked]="!broadcastNow" color="primary">{{
          getQueueText()
        }}</mat-radio-button>
      </div>
    </div>
  </div>
}

<div mat-dialog-actions align="end">
  <button data-testid="dialogSecondaryButton" mat-button mat-dialog-close (click)="onSecondaryClicked()">CANCEL</button>
  @if (!showPreviewSection) {
    <button
      data-testid="dialogPrimaryButton"
      [disabled]="isButtonDisabled('next')"
      mat-button
      (click)="onPrimaryClicked('next')"
    >
      NEXT
    </button>
  }
  @if (showPreviewSection) {
    <button
      data-testid="dialogPrimaryButton"
      [disabled]="isButtonDisabled('ok')"
      mat-button
      (click)="onPrimaryClicked('ok')"
    >
      OK
    </button>
  }
</div>
